// extracted by mini-css-extract-plugin
module.exports = {"l1q6lkcx":"l1q6lkcx"};